"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("./constants");

var _treeNode = _interopRequireDefault(require("./treeNode"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

(function () {
  var styles = "@font-face {\n  font-family: 'OpenSansRegular';\n  src: url(\"../assets/font/OpenSans-latin-normal.woff2\") format(\"woff2\"); }\n\n.tree-bounding-container {\n  position: relative;\n  height: 100%; }\n\n.tree-container {\n  display: inline-block;\n  width: 19rem;\n  height: 100%;\n  overflow: hidden; }\n  .tree-container:hover {\n    overflow: overlay; }\n\n@-moz-document url-prefix() {\n  .tree-container:hover {\n    overflow: auto;\n    scrollbar-color: #c6c6c6; }\n  .tree-container::-webkit-scrollbar {\n    width: 0.5rem;\n    border-radius: 0.625rem; }\n  .tree-container::-webkit-scrollbar-track {\n    background: transparent; }\n  .tree-container::-webkit-scrollbar-thumb {\n    background: #c6c6c6;\n    border-radius: 0.625rem; }\n  .tree-container::-webkit-scrollbar-thumb:hover {\n    background: #6f6f6f;\n    border-radius: 0.625rem; } }\n\n.tree-container::-webkit-scrollbar {\n  width: 0.5rem;\n  border-radius: 0.625rem; }\n\n.tree-container::-webkit-scrollbar-track {\n  background: transparent; }\n\n.tree-container::-webkit-scrollbar-thumb {\n  background: #c6c6c6;\n  border-radius: 0.625rem; }\n\n.tree-container::-webkit-scrollbar-thumb:hover {\n  background: #6f6f6f;\n  border-radius: 0.625rem; }\n\n.tree-resize-line {\n  display: inline-block;\n  position: absolute;\n  height: 100%;\n  width: 0.125rem;\n  cursor: col-resize;\n  pointer-events: auto;\n  background-color: #a8a8a8;\n  margin-left: 0.0625rem; }\n\n.tree-resize-line:hover {\n  background-color: #067fdb;\n  cursor: col-resize;\n  pointer-events: auto; }\n\n.tree-resize-line:active {\n  background-color: #067fdb;\n  cursor: col-resize;\n  pointer-events: auto; }\n";
  var fileName = "compone_tree";
  var element = document.querySelector("style[data-sass-component='compone_tree']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var Tree = function Tree(_ref) {
  var nodes = _ref.nodes,
      clickHandler = _ref.clickHandler,
      expandIconClickHandler = _ref.expandIconClickHandler,
      actionClickHandler = _ref.actionClickHandler,
      topPadding = _ref.topPadding,
      selectedItemParents = _ref.selectedItemParents,
      expandedItems = _ref.expandedItems;
  var container = (0, _react.useRef)();
  var resizeLineRef = (0, _react.useRef)();

  var resize = function resize(event) {
    var Rect = container.current.getBoundingClientRect();
    var trueLeft = Rect.left + window.pageXOffset;
    var width = event.pageX - trueLeft;
    container.current.style.width = parseInt(width) + 'px';
  };

  (0, _react.useLayoutEffect)(function () {
    var Rect = container.current.getBoundingClientRect();
    resizeLineRef.current.style.top = window.pageYOffset + Rect.top;
    resizeLineRef.current.style.right = window.pageXOffset + Rect.left;
  }, []);
  (0, _react.useEffect)(function () {
    resizeLineRef.current.addEventListener(_constants.mousedownEvent, function (event) {
      var Rect = resizeLineRef.current.getBoundingClientRect();
      var trueRight = Rect.right + window.pageXOffset; // add 4 to set a comfortable range for pointer event

      if (event.pageX > trueRight - 4 && event.pageX < trueRight + 4) {
        document.addEventListener(_constants.mousemoveEvent, resize, false);
      }
    }, false);
    document.addEventListener(_constants.mouseupEvent, function () {
      document.removeEventListener(_constants.mousemoveEvent, resize, false);
    });
  }, []);
  var treeNodeProps = {
    nodes: nodes,
    level: 0,
    parents: [],
    clickHandler: clickHandler,
    expandIconClickHandler: expandIconClickHandler,
    actionClickHandler: actionClickHandler,
    selectedItemParents: selectedItemParents,
    expandedItems: expandedItems
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.TreeClass.boundingContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    ref: container,
    style: {
      paddingTop: topPadding
    },
    className: _constants.TreeClass.container,
    tabIndex: _constants.tabIndex
  }, /*#__PURE__*/_react.default.createElement(_treeNode.default, treeNodeProps)), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.TreeClass.resize,
    ref: resizeLineRef
  }));
};

var recursiveShapeType = function recursiveShapeType() {
  var propsType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var recursiveKey = arguments.length > 1 ? arguments[1] : undefined;

  var type = function type() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _propTypes.default.shape(propsType).apply(null, args);
  };

  propsType[recursiveKey] = _propTypes.default.arrayOf(type);
  return type;
};

Tree.propTypes = {
  nodes: _propTypes.default.shape({
    label: _propTypes.default.string.isRequired,
    leaves: _propTypes.default.any,
    hasChildren: _propTypes.default.bool.isRequired,
    actionItems: _propTypes.default.any,
    details: _propTypes.default.any,
    nodes: _propTypes.default.arrayOf(recursiveShapeType({
      label: _propTypes.default.string.isRequired,
      leaves: _propTypes.default.arrayOf(_propTypes.default.object),
      hasChildren: _propTypes.default.bool.isRequired,
      actionItems: _propTypes.default.any,
      details: _propTypes.default.any
    }, _constants.recursivePropName))
  }).isRequired,
  clickHandler: _propTypes.default.func.isRequired,
  topPadding: _propTypes.default.string,
  expandIconClickHandler: _propTypes.default.func.isRequired,
  actionClickHandler: _propTypes.default.func.isRequired,
  expandedItems: _propTypes.default.array,
  selectedItemParents: _propTypes.default.array.isRequired
};
var _default = Tree;
exports.default = _default;